module.exports = __webpack_public_path__ + "static/media/2OMB-WFTM.df2e3175.png";